import { render, staticRenderFns } from "./EditMyProfileDetailsDialog.vue?vue&type=template&id=38a5fa77&scoped=true&"
import script from "./EditMyProfileDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./EditMyProfileDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditMyProfileDetailsDialog.vue?vue&type=style&index=0&id=38a5fa77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a5fa77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
